<template>
  <div class="photoDetails">
    <div class="moyenCadrePhoto">
      <Photo :profile="prf" :pic="prf.mainPicture" />
    </div>
    <div class="details">
      <div class="pseudo">
        <Pseudo :profile="prf" />, {{ prf.city.name }}({{ prf.city.zip }}), {{ prf.city.country.name }}
      </div>
      <div class="cree">
        Créé le {{ idyuFormatDate(prf.creationDate) }} <strong class="adw" v-if="adw"> via Adwords</strong>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import Photo from "@/components/profile/Photo";
import Pseudo from "@/components/profile/Pseudo";
import { idyuFormatDate } from "../../assets/js/idyu/util";

export default {
  props: ["prf", "usr"],
  components: { Photo, Pseudo },
  methods: {
    idyuFormatDate: idyuFormatDate
  },
  computed: {
    adw() {
      return this.usr.subscriptionType == 10;
    }
  }
};
</script>

<style scoped>
.photoDetails {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
  grid-template-columns: auto 1fr;
}

.details {
  display: grid;
  grid-gap: 5px;
  align-items: baseline;
  grid-auto-rows: min-content;
}

.cree {
  font-style: italic;
  color: #aaa;
}

.adw {
  color: green;
}
</style>
